import { PatientMyProfileState } from '../slices/patientMyProfileSlice';
import { RootState } from '../store';

export const selectPatientMyProfile = (state: RootState): PatientMyProfileState => state.patientMyProfile;
